module.exports = __webpack_public_path__ + "img/guernsey.71517d48.svg";